import {
  cloneElement,
  isValidElement,
  type ReactElement,
  type ReactNode,
} from "react";

/** Compact action button sizing for page headers on mobile. */
export function withPageHeaderActionStyles(actionButton: ReactNode): ReactNode {
  if (!isValidElement(actionButton)) return actionButton;

  const props = actionButton.props as Record<string, unknown>;

  return cloneElement(actionButton as ReactElement<Record<string, unknown>>, {
    ...(props.size === undefined ? { size: { base: "sm", md: "md" } } : {}),
    ...(props.h === undefined ? { h: { base: "36px", md: "44px" } } : {}),
    ...(props.whiteSpace === undefined ? { whiteSpace: "nowrap" } : {}),
  });
}
